import { el, clear } from "../components/dom.js";
import { searchBar } from "../components/search-bar.js";
import { expandableResultCard } from "../components/search-result.js";
import { searchTv } from "../api/tv.js";
import { addTvSeries, deleteByTvmazeId, listTvSeries } from "../db/tv.js";
import { navigateBack } from "../main.js";
import { magScreenHead, MAG } from "../components/magazine/kit.js";

export async function renderAddTv(root) {
	const head = magScreenHead("Add a Show", {
		eyebrow: "Find & collect",
		eyebrowColor: "#19d3e8",
		onBack: () => navigateBack("/tv"),
	});

	const resultsContainer = el("div", { style: { display: "flex", flexDirection: "column", gap: "9px", padding: "6px 0 24px" } });
	const statusLine = el("div", {
		style: {
			fontFamily: "'Archivo', sans-serif", fontWeight: "900", fontSize: "9.5px",
			letterSpacing: ".14em", textTransform: "uppercase", color: MAG.lime, padding: "10px 0 4px",
		},
	});

	const existing = await listTvSeries();
	const addedIds = new Set(existing.map((t) => t.tvmaze_id));

	let inflight = null;
	let lastResults = [];

	function renderResults() {
		clear(resultsContainer);
		for (const result of lastResults) {
			resultsContainer.append(
				expandableResultCard({
					cover_url: result.cover_url,
					mediaType: "tv",
					title: result.title,
					subtitle: result.premiered_year ? String(result.premiered_year) : "",
					summary: result.summary ?? "",
					details: [{ label: "Status", value: result.status ?? "" }],
					added: addedIds.has(result.tvmaze_id),
					onToggleAdd: (want) => toggle(result, want),
				}),
			);
		}
	}

	// Returns the resulting added-state so the card can repaint in place.
	async function toggle(result, want) {
		try {
			if (!want) {
				await deleteByTvmazeId(result.tvmaze_id);
				addedIds.delete(result.tvmaze_id);
				return false;
			}
			await addTvSeries({
				tvmaze_id: result.tvmaze_id,
				title: result.title,
				premiered_year: result.premiered_year ?? null,
				cover_url: result.cover_url ?? null,
				summary: result.summary ?? null,
			});
			addedIds.add(result.tvmaze_id);
			return true;
		} catch (err) {
			statusLine.textContent = `Could not ${want ? "add" : "remove"}: ${err.message}`;
			throw err;
		}
	}

	async function runSearch(q) {
		if (inflight) inflight.abort();
		lastResults = [];
		clear(resultsContainer);
		statusLine.textContent = "";
		if (!q) return;

		const controller = new AbortController();
		inflight = controller;
		statusLine.textContent = "Searching…";
		try {
			const results = await searchTv(q, { signal: controller.signal });
			if (controller.signal.aborted) return;
			lastResults = results;
			statusLine.textContent = results.length
				? `${results.length} result${results.length === 1 ? "" : "s"}`
				: "No results.";
			renderResults();
		} catch (err) {
			if (err.name === "AbortError") return;
			statusLine.textContent = `Error: ${err.message}`;
		} finally {
			if (inflight === controller) inflight = null;
		}
	}

	const bar = searchBar({
		placeholder: "Search TV series…",
		onInput: (q) => runSearch(q),
	});

	root.append(
		el(
			"div.view",
			{},
			head,
			el("div", { style: { padding: "14px 0 0" } }, bar.node),
			statusLine,
			resultsContainer,
		),
	);
}
